// extracted by mini-css-extract-plugin
export default {"logoContainer":"logoContainer-tNpFvd5L","logo":"logo-q9mImiEp","heading":"heading-IpR8ozzh","timeTurns":"timeTurns-hbwFfmyk"};